import React, {Component} from "react";
import "./EditAddress.css";
import {FormattedMessage} from "react-intl";
import {Modal} from "react-bootstrap";
import axios from "axios";
import AddressTable from "../../UserProfile/UserAddressTable/UserAddressTable";

import {RESOURCE_BASE_URL} from "../../../../configuration";

let userId;

class EditAddress extends Component {

    constructor(props) {
        super(props);

        this.state = {
            show: false,
            showDetails: false,
            selected: '',
            shipping: true,
            userId: "",
            userAddresses: [],
            userInfo: {}
        };

        this.moreButtonCLicked = this.moreButtonCLicked.bind(this);
        this.handleShow = this.handleShow.bind(this);
        this.getUserAddressesOrderConfirm = this.getUserAddressesOrderConfirm.bind(this);
        this.getUserDetailsOrderConfirm = this.getUserDetailsOrderConfirm.bind(this);
    }

    handleShow = () => {
        this.setState({show: true});
    };

    handleClose = () => {
        this.setState({show: false});
    };

    moreButtonCLicked = () => {
        this.setState({
            showDetails: !this.state.showDetails
        });
    };

    getUserAddressesOrderConfirm = () => {
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };
        axios.get(RESOURCE_BASE_URL + 'api/users/' + this.props.userId + '/addresses', axiosConfig)
            .then((res) => {
                this.setState({
                    userAddresses: res.data
                });
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });
    };

    getUserDetailsOrderConfirm = (userId) => {
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };
        axios.get(RESOURCE_BASE_URL + 'api/users/' + userId, axiosConfig)
            .then((res) => {
                this.setState({
                    userInfo: res.data
                });

            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });
    };


    componentDidMount() {
        userId = this.props.userId;

        // this.getUserAddressesOrderConfirm(this.props.userId);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        // this.getUserAddressesOrderConfirm(userId);

    }

    componentWillUnmount() {
        // this.getUserAddressesOrderConfirm(userId);

    }

    // componentWillMount() {
    //     this.getUserAddressesOrderConfirm(userId);
    //
    // }

    render() {
        let no = 1;
        return (
            <span>
                <a className="pull-right  edit-address-pointer" onClick={this.handleShow}>
                    <FormattedMessage id="app.order.confirm.edit"
                                      defaultMessage="Edit"
                                      description=""/>
                </a>

                <Modal dialogClassName="order-confirmation-address-modal" show={this.state.show}
                       onHide={this.handleClose}>
                    <Modal.Header closeButton>
                        <div className="title-1 color-text">
                             <FormattedMessage id="app.user-profile.user-edit-address.edit-ship-bill"
                                               defaultMessage="Edit Shipping/Billing Address"
                                               description=""/>

                        </div>
                    </Modal.Header>

                    <Modal.Body>
                        <div id="editAddress-table-mobile">
                            <AddressTable
                                userInfo={this.props.userInfo}
                                userAddresses={this.props.userAddresses}
                                getUserAddresses={this.props.getUserAddresses}
                                getUserDetails={this.props.getUserDetails}
                                userId={this.props.userId}
                            />
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <div className="add-new-address-div">
                            <button className="btn btn-default" onClick={this.handleClose}>
                                <FormattedMessage id="app.user-profile.user-edit-address.close"
                                                  defaultMessage="Close"
                                                  description=""/>
                            </button>
                        </div>
                    </Modal.Footer>
                </Modal>
    </span>
        )
            ;
    }

}

export default EditAddress;



// WEBPACK FOOTER //
// ./src/components/Site/Order/EditAddress/EditAddress.js